'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSite from "./presto.types$-Site.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Site$() {
}
export { $c_Lpresto_types$Site$ as $c_Lpresto_types$Site$ };
$p = $c_Lpresto_types$Site$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Site$;
/** @constructor */
function $h_Lpresto_types$Site$() {
}
export { $h_Lpresto_types$Site$ as $h_Lpresto_types$Site$ };
$h_Lpresto_types$Site$.prototype = $p;
$p.l = (function() {
  return "Site";
});
$p.iH = (function(x$0) {
  return new $j_presto$002etypes$0024$002dSite.$c_Lpresto_types$Site($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1), x$0.j(2), x$0.j(3), (!(!x$0.j(4))), x$0.j(5), x$0.j(6), (!(!x$0.j(7))), (!(!x$0.j(8))), x$0.j(9), x$0.j(10), x$0.j(11), x$0.j(12), x$0.j(13), x$0.j(14), x$0.j(15));
});
var $d_Lpresto_types$Site$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Site$, "presto.types$Site$", ({
  a1K: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$Site$ as $d_Lpresto_types$Site$ };
var $n_Lpresto_types$Site$;
function $m_Lpresto_types$Site$() {
  if ((!$n_Lpresto_types$Site$)) {
    $n_Lpresto_types$Site$ = new $c_Lpresto_types$Site$();
  }
  return $n_Lpresto_types$Site$;
}
export { $m_Lpresto_types$Site$ as $m_Lpresto_types$Site$ };
//# sourceMappingURL=presto.types$-Site$.js.map
